import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  HostListener,
  input,
  output,
} from '@angular/core';

import { Icon, IconComponent } from '../icon';

export type ToggleState = 'on' | 'off';

@Component({
  selector: 'smw-toggle',
  imports: [IconComponent],
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleComponent {
  state = input<ToggleState>('off');
  expanded = input(false);
  disabled = input(false);
  changed = output<ToggleState>();

  onIcon = Icon.check;
  offIcon = Icon.close;

  isOn = computed(() => this.state() === 'on');

  @HostBinding('class.expanded') get expandedClass(): boolean {
    return this.expanded();
  }

  @HostBinding('class.on') get onClass(): boolean {
    return this.isOn();
  }

  @HostBinding('class.disabled') get disabledClass(): boolean {
    return this.disabled();
  }

  @HostBinding('attr.aria-disabled') get ariaDisabledAttr(): boolean {
    return this.disabled();
  }

  @HostListener('click', ['$event']) onClick(event: MouseEvent): void {
    event.stopPropagation();
    const state: ToggleState = this.isOn() ? 'off' : 'on';
    this.changed.emit(state);
  }
}
